import {
    Component,
    EventEmitter,
    Input,
    OnDestroy, OnInit,
    Output
} from '@angular/core';
import { ZipCodeRangeModel } from '../../../shared/models/zip-code-range.model';
import { DeliveryStepsService } from '../../services/delivery-steps.service';
import { ScheduleService } from '../../services/schedule.service';
import { SchedulingSettingPeriod } from '../../../shared/models/scheduling-setting-period';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs/Subscription';

@AutoUnsubscribe()
@Component({
    selector: 'payment-delivery-freights',
    templateUrl: './payment.delivery.freights.component.html',
    styleUrls: ['../../payment.component.scss']

})
export class PaymentDeliveryFreightsComponent implements OnInit, OnDestroy {
    public loading = false;
    public attempt = 0;
    public freights: Array<ZipCodeRangeModel> = [];
    public definedFreightMethod = false;
    public selectedFreight: ZipCodeRangeModel = null;
    public selectedScheduleDate: string = null;
    public selectedSchedulePeriod: SchedulingSettingPeriod = null;
    @Output() ready: EventEmitter<ZipCodeRangeModel> = new EventEmitter();
    @Input() deliveryAddressReady = false;

    deliveryStepsLoadingFreights: Subscription;
    deliveryStepsLoadedFreights: Subscription;
    deliveryStepsSelectedAddress: Subscription;
    deliveryStepsSelectedAddressLoadFreights: Subscription;
    deliveryStepsResetedSelectedAddress: Subscription;
    scheduleServiceSelectedScheduleDate: Subscription;
    scheduleServiceSelectedSchedulePeriod: Subscription;

    constructor(
        protected deliverySteps: DeliveryStepsService,
        protected scheduleService: ScheduleService
    ) { }

    ngOnInit() {
        this.deliveryStepsLoadingFreights = this.deliverySteps.loadingFreights$.subscribe(() => {
            this.loading = true;
        });
        this.deliveryStepsLoadedFreights = this.deliverySteps.loadedFreights$.subscribe(() => {
            this.freights = this.deliverySteps.getFreights();
            this.loading = false;
        });
        this.deliveryStepsSelectedAddress = this.deliverySteps.selectedAddress$.subscribe(() => {
            this.deliveryStepsSelectedAddressLoadFreights = this.deliverySteps.loadFreights().subscribe();
        });
        this.deliveryStepsResetedSelectedAddress = this.deliverySteps.resetedSelectedAddress$.subscribe(() => {
            this.selectedFreight = null;
            this.deliverySteps.resetFreights();
        });
        this.scheduleServiceSelectedScheduleDate = this.scheduleService.selectedScheduleDate$.subscribe(date => {
            this.selectedScheduleDate = date;
        });
        this.scheduleServiceSelectedSchedulePeriod = this.scheduleService.selectedSchedulePeriod$.subscribe(period => {
            this.selectedSchedulePeriod = period;
        });
    }
    ngOnDestroy() {
        // Overrided by AutoUnsubscribe
    }

    /**
     * This mark selected freight.
     **/
    public onChangedFreight(freight: ZipCodeRangeModel): void {
        this.selectedFreight = freight;
    }
    /**
     * This returns true if has some selected freight.
     **/
    public hasSelectedFreight(): boolean {
        return this.selectedFreight != null;
    }
    /**
     * Selected freight requires schedule when scheduling settings is present.
     **/
    public selectedFreightRequiresSchedule(): boolean {
        if (!this.hasSelectedFreight()) {
            return false;
        }

        return this.selectedFreight.scheduling_settings !== undefined
            && this.selectedFreight.scheduling_settings.length > 0;
    }
    /**
     * Selected freight requires schedule when scheduling settings is present.
     **/
    public hasSelectedSchedule(): boolean {
        return this.selectedScheduleDate !== undefined
            && this.selectedSchedulePeriod !== undefined;
    }
    /**
     * User can continue to payment when has selected freight and them dont
     * requires schedule configuration or when freight requires configuration
     * and schedule is configurated.
     *
     * @return boolean
     **/
    public canContinue(): boolean {
        return (this.hasSelectedFreight() && !this.selectedFreightRequiresSchedule())
            || (this.selectedFreightRequiresSchedule() && this.hasSelectedSchedule());
    }
    /**
     * This mark definedFreightMethod flag and emit freightWasSelected event.
     **/
    public next() {
        this.attempt += 1;
        if (this.canContinue()) {
            this.definedFreightMethod = true;
            this.deliverySteps.setSelectedFreight(this.selectedFreight);
            this.ready.emit(this.selectedFreight);
        }
    }
    /**
     * Has no selected freight error message must be hidden if selected
     * freight or proceed to payment is not attempted.
     **/
    public hiddenHasNoSelectedFreightError() {
        return this.hasSelectedFreight() || this.attempt === 0;
    }
    /**
     * Has no selected schedule error message must be hidden if selected
     * freight not requires schedule or schedule is selected or proceed to
     * payment is not attempted.
     **/
    public hiddenHasNoSelectedScheduleError() {
        return !this.selectedFreightRequiresSchedule()
            || this.hasSelectedSchedule()
            || this.attempt === 0;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/payment/delivery/freights/payment.delivery.freights.component.ts